<template>
    <div class="card">
        <div class="card-body staking-card">
          <div class="row">
            <div class="col-10 col-md-11">
              <h5 class="card-title"><span class="aht">{{ $t('general.aht') }}</span> {{ $t('stakingSystem.title') }}</h5>
            </div>
          </div>
          <hr class="mt-0 mb-2">
          <div class="send-stake" v-if="!stakeStatus && !sending">
            <div class="row pt-4">
              <div class="offset-md-1 col-md-2 d-flex align-items-center justify-content-center">
                {{ $t('stakingSystem.stake') }}
              </div>
              <div class="col-md-6 text-center">
                <input @keydown="onlyNumbers"
                  type="number"
                  placeholder="0"
                  class="form-control stake-amount"
                  v-model="stakeAmount"
                  :disabled="isDisabled">
                <div class="error pt-2" v-if="isDisabled">{{ $t('stakingSystem.connectedToStake') }}</div>
                <div class="error pt-2" v-if="!isDisabled && balance === 0">{{ $t('stakingSystem.haveAHTToStake') }}</div>
                <div class="error pt-2" v-if="!isDisabled && balance > 0 && !enoughtAHT">{{ $t('stakingSystem.notEnough') }}</div>
              </div>
              <div class="col-md-2 d-flex align-items-center justify-content-center">
                {{ $t('general.aht') }}
              </div>
            </div>
            <div class="row pt-1 pt-md-4 pb-md-2">
              <div class="col-12 offset-md-3 col-md-6 pt-2 mt-md-0">
                <button type="button"
                  class="btn btn-block send"
                  @click="staking"
                  :disabled="isDisabled">
                  {{ $t('stakingSystem.send') }}
                </button>
              </div>
            </div>
          </div>
          <div class="stop-stake pt-4 pb-3" v-if="stakeStatus && !sending">
            <div class="row pt-4 pb-4">
              <div class="offset-1 col-10 offset-lg-2 col-lg-8 text-center">
                <label class="pb-3">
                  {{ $t('stakingSystem.amountStaking', { amount: amountStaked }) }}
                </label>
                <button type="button"
                class="btn btn-block stop"
                @click="stopStaking">
                {{ $t('stakingSystem.stop') }}
              </button>
              </div>
            </div>
          </div>
          <div class="no-items" v-if="sending">
            <div class="row h-100">
              <div class="col-md-12 d-flex align-items-center justify-content-center">
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              </div>
              <div class="col-md-12 pt-1 text-center">
                <h6>{{ $t('general.sending') }}</h6>
              </div>
            </div>
          </div>
          <div class="row info-address pb-3">
            <div class="col-12 pt-2 pb-2 your-contract">
              {{ $t('stakingSystem.address') }}
            </div>
            <div class="col-8 pt-2 ml-2 address">
              {{ address }}
            </div>
            <div class="col-1">
              <button class="btn copy" v-clipboard="address" @click="showPopover" data-container="body" data-toggle="popover" data-placement="top" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
                <i class="far fa-copy"></i>
              </button>
            </div>
            <transition name="fade">
              <div v-if="show" class="col-2 copied text-center">
                Copied
              </div>
            </transition>
          </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Swal from 'sweetalert2'

export default {
  computed: {
    amountStaked() {
      return this.$store.getters.getAmountStakedByUser
    },
    address () {
      return process.env.VUE_APP_SURVEY_ADDRESS
    },
    balance () {
      return this.$store.getters.getBalance
    },
    isDisabled () {
      return !this.$store.getters.getIsConnected
    },
    currentAccount () {
      return this.$store.getters.getAddress
    },
    stakeStatus () {
      return this.$store.getters.getStakeStatus
    },
    enoughtAHT () {
      return this.balance >= this.stakeAmount
    }
  },
  data () {
    return {
      reward: 1,
      stakeAmount: null,
      sending: false,
      show: false
    }
  },
  methods: {
    changeReward (reward) {
      this.reward = reward

      this.$store.dispatch('setTypeReward', this.reward)
    },
    async staking () {
      await this.$store.dispatch('getBalance', this.currentAccount)

      if (this.stakeAmount > 0) {

        if (this.balance !== 1) {

          if (this.balance >= this.stakeAmount) {

            try {
              this.sending = true

              await this.$store.dispatch('sendStake', {
                address: this.currentAccount,
                stakeAmount: this.stakeAmount
              })

              this.$store.dispatch('getBalance', this.currentAccount)

              this.$store.dispatch('getStakingInfo', this.currentAccount)

              this.sending = false

              this.stakeAmount = 0

              Swal.fire({
                title: 'Success',
                text: this.$t('stakingSystem.stakeSuccessfully'),
                icon: 'success',
                confirmButtonText: 'Ok'
              })
            } catch (error) {
              this.sending = false
              console.log(error)
            }

          } else {
            Swal.fire({
              title: 'Error',
              text: this.$t('stakingSystem.notEnough'),
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }
        } else {
          Swal.fire({
            title: 'Error',
            text: this.$t('stakingSystem.moreThanOneAHT'),
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }
      } else {
        Swal.fire({
            title: 'Error',
            text: this.$t('stakingSystem.amountMoreThanZero'),
            icon: 'error',
            confirmButtonText: 'Ok'
          })
      }
    },
    async stopStaking () {
      this.sending = true
      try {
        await this.$store.dispatch('stopStake', this.currentAccount)
      } catch (error) {
        this.sending = false
      }

      await this.$store.dispatch('getVoteInfo', this.currentAccount)
      await this.$store.dispatch('getStakingInfo', this.currentAccount)
      this.sending = false
    },
    onlyNumbers ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)

      if (keyCode !== 8 && keyCode !== 190 && keyCode !== 46 
        && keyCode !== 37 && keyCode !== 39) {
        if (isNaN(Number($event.key))) {
          $event.preventDefault()
        }
      }

      if(this.stakeAmount) {
        if (this.stakeAmount.length >= 18) {
          if(keyCode !== 8 && keyCode !== 37 && keyCode !== 39)
            $event.preventDefault()
        }
      }
    },
    showPopover () {
      this.show = true

      setTimeout(() => {
        this.show = false
       }, 2000).bind(this);
    }
  },
  watch : {
    currentAccount: async function (val) {
      if (val) {
        await this.$store.dispatch('getStakingInfo', this.currentAccount)
        await this.$store.dispatch('getBalance', this.currentAccount)
      }
    }
  }
}
</script>

<style scoped>
hr {
  margin-top: .7rem;
  margin-bottom: 0rem;
}

.card {
  color: white;
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border-radius: 20px;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
}

.staking-card {
  padding-bottom: 0;
  padding-left: 15px;
  padding-right: 15px;
}

.aht {
  color: #66c9d8;
}

.card-title {
  font-size: 17px;
  font-weight: 900;
}

.pay-option {
  color: #4e9ea5;
  margin-top: 0;
  border-radius: 10px;
  background: rgb(26,59,83);
  background: linear-gradient(180deg, rgba(26,59,83,1) 30%, rgba(16,38,54,1) 100%);
  border: 1px solid #213b4d;
  text-transform: none;
}

.selected {
  color: white;
  box-shadow: 12px 12px 16px 0 rgba(255, 255, 255, 0.5) inset,
    -8px -8px 12px 0 rgba(255, 255, 255, 0.5) inset;
}

.send-stake {
  max-height: 211px;
  height: 211px;
}

.info-address {
  background: #2E3031 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 20px 20px;
  opacity: 1;
  padding-left: 15px;
}

.your-contract {
  font: normal normal 600 14px/18px Poppins;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}

.address {
  text-align: left;
  font: normal normal normal 11.5px Poppins;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  background: #212627 0% 0% no-repeat padding-box;
  border-radius: 10px;
}

.copy {
  color: #fff;
  background: #61C9D9 0% 0% no-repeat padding-box;
  border-radius: 11px;
  opacity: 1;
}

.copied {
  font-size: .75rem;
  padding-top: .55rem;
  margin-left: 1rem;
  background: #212627 0% 0% no-repeat padding-box;
  color: #fff;
  border-radius: 15px;
}

.stake-amount {
  border-radius: 13px;
  background: #212627 0% 0% no-repeat padding-box;
  border-radius: 12px;
  opacity: 1;
  outline: none;
  height: 54pt;
  font-size: 18px;
  text-align: center;
  color: white;
  border: none;
}

.error {
  font-size: 0.75rem;
  color: #f57f6c;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.send {
  color: white;
  border: none;
  background: rgb(26,161,181);
  background: linear-gradient(357deg, rgba(26,161,181,1) 0%, rgba(0,222,255,1) 100%);
  border-radius: 3px;
  font-weight: 900;
  margin-top: 0;
}

.stop {
  color: white;
  border: none;
  background: rgb(222,127,127);
  background: linear-gradient(180deg, rgba(222,127,127,1) 0%, rgba(255,63,38,1) 53%);
  border-radius: 3px;
  font-weight: 900;
  margin-top: 0;
  height: 70px;
}

.stop-stake {
  max-height: 211px;
  height: 211px;
}

.icon-copy {
  position: absolute;
  right: 2rem;
  top: .5rem;
}

.staking-note {
  font-size: 11.5px;
  color: #72a5ad;
}

.no-items {
  height: 210px;
  max-height: 210px;
  text-align: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
